export default __webpack_public_path__ + "static/media/sortBy.a0a5a374.svg";